import { motion } from "framer-motion";
import { CalendarCheck, Timer, Sliders } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Icon3D } from "./Icon3D";

const items = [
  {
    icon: CalendarCheck,
    title: "Agendamento",
    desc: "Atendimentos previsíveis e planejados.",
    variant: "deepBlue",
    accent: "#3532B3",
  },
  {
    icon: Timer,
    title: "Fila em tempo real",
    desc: "Atendimento imediato conforme demanda.",
    variant: "vividBlue",
    accent: "#3787F5",
  },
  {
    icon: Sliders,
    title: "Ajuste de capacidade",
    desc: "Estrutura flexível adaptada ao volume da operação.",
    variant: "aqua",
    accent: "#12DDB5",
  },
];

export const FlexibleModel = () => {
  return (
    <section
      id="modelo-flexivel"
      data-testid="flexible-model-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Modelo de operação"
          title="Modelo de operação"
          highlight="flexível"
          subtitle="A Previsa Saúde combina previsibilidade com agilidade para absorver variações de demanda com rapidez, qualidade e controle técnico."
          testid="flexible-heading"
        />

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((it, idx) => (
            <motion.article
              key={it.title}
              data-testid={`flex-card-${idx}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.55,
                ease: [0.16, 1, 0.3, 1],
                delay: idx * 0.08,
              }}
              whileHover={{ y: -6 }}
              className="group relative bg-gradient-to-br from-white to-[#F6F8FB] rounded-3xl border border-[#E5EAF2] p-8 md:p-10 hover:shadow-[0_24px_60px_rgba(53,50,179,0.10)] hover:border-[#3787F5]/30 transition-all duration-300 overflow-hidden"
            >
              <span
                className="absolute -right-12 -top-12 w-44 h-44 rounded-full opacity-[0.08] group-hover:opacity-[0.18] transition-opacity duration-500"
                style={{ background: it.accent }}
              />
              <Icon3D
                icon={it.icon}
                variant={it.variant}
                size="lg"
                className="relative mb-6 group-hover:scale-110 group-hover:-rotate-3"
              />
              <h3 className="relative text-xl font-bold text-[#1F2937]">
                {it.title}
              </h3>
              <p className="relative mt-3 text-[#64748B] leading-relaxed">
                {it.desc}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
